module.exports = __webpack_public_path__ + "static/media/CIAP-16.fc2e2f9d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/Experience/Events/CIAP-16.jpg
// module id = 664
// module chunks = 0